import React from 'react';
import { Alert, AlertTitle, Box, Chip, Typography } from '@mui/material';
import { useAdminScope } from '../contexts/AdminScopeContext';

interface ScopeRequirementAlertProps {
  requiredScope: 'group' | 'store';
  title: string;
  description: string;
}

const ScopeRequirementAlert: React.FC<ScopeRequirementAlertProps> = ({
  requiredScope,
  title,
  description,
}) => {
  const { activeScopeType, selectedGroup, selectedStore } = useAdminScope();

  return (
    <Alert severity="info" sx={{ mt: 2 }}>
      <AlertTitle>{title}</AlertTitle>
      <Typography variant="body2" sx={{ mb: 1 }}>
        {description}
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
        <Chip label={`Scope actif: ${activeScopeType}`} size="small" />
        {selectedGroup && <Chip label={`Groupe: ${selectedGroup.name}`} size="small" />}
        {selectedStore && <Chip label={`Magasin: ${selectedStore.name}`} size="small" />}
        <Chip
          color="primary"
          size="small"
          label={`Scope requis: ${requiredScope === 'store' ? 'magasin' : 'groupe'}`}
        />
      </Box>
    </Alert>
  );
};

export default ScopeRequirementAlert;
